// src/components/sections/Markets.jsx
import React from 'react';

const marketData = [
  { pair: 'BTC/USD', price: 68901.23, change: 2.35, volume: 1.52, icon: 'fa-btc', color: '#f7931a' },
  { pair: 'ETH/USD', price: 3825.40, change: 1.15, volume: 0.89, icon: 'fa-ethereum', color: '#627EEA' },
  { pair: 'SOL/USD', price: 185.75, change: -0.52, volume: 0.45, icon: 'fa-sun', color: '#9945FF' },
  { pair: 'BNB/USD', price: 580.12, change: 3.01, volume: 0.73, icon: 'fa-btc', color: '#F3BA2F' },
  { pair: 'AVAX/USD', price: 42.60, change: -1.28, volume: 0.22, icon: 'fa-snowflake', color: '#E84142' },
];

const Markets = () => {
  return (
    <section className="markets" id="markets">
      <div className="container">
        <div className="section-title fade-in">
          <h2>Active <span>Perpetual</span> Markets</h2>
          <p>Trade the most popular crypto assets with up to 100x leverage.</p>
        </div>

        <div className="markets-table scale-in">
          <div className="table-header">
            <div>Asset</div>
            <div>Price</div>
            <div className="hide-mobile">24h Change</div>
            <div className="hide-mobile">24h Volume (B)</div>
            <div>Trade</div>
          </div>
          
          {marketData.map((market, index) => (
            <div key={market.pair} className="table-row">
              <div className="coin">
                <div className="coin-icon" style={{ backgroundColor: market.color, color: 'var(--background-color)' }}>
                    {/* Note: I used fa-btc for BNB as a placeholder since it doesn't have a unique fa icon */}
                    <i className={`fab ${market.icon}`}></i> 
                </div>
                <strong>{market.pair}</strong>
              </div>
              <div>${market.price.toLocaleString()}</div>
              <div className={`hide-mobile ${market.change > 0 ? 'positive' : 'negative'}`}>
                {market.change > 0 ? '+' : ''}{market.change}%
              </div>
              <div className="hide-mobile">${market.volume}</div>
              <div>
                <button className="btn btn-primary" style={{ padding: '8px 15px' }}>Trade</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Markets;